import { gql } from '@apollo/client';

export const CREATE_FORM_SUBMISSION = gql`
  mutation CreateFormSubmission($data: mutationFormSubmissionInput!, $draft: Boolean) {
    createFormSubmission(data: $data, draft: $draft) {
      id
    }
  }
`;
